"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormViewPayloadFactoryFromJS = exports.FormViewPayloadFactory = void 0;
const immutable_1 = require("immutable");
const IFormViewItem_1 = require("./IFormViewItem");
exports.FormViewPayloadFactory = (0, immutable_1.Record)({
    windowId: null,
    originalActionType: null,
    views: (0, immutable_1.List)(),
    view: (0, IFormViewItem_1.FormViewItemFactory)(),
    pluginId: null,
    sourceWindowId: null,
    autoClean: false,
    updatedViewName: null
});
const FormViewPayloadFactoryFromJS = function (data) {
    const views = data.views && data.views.length ? data.views.map(i => (0, IFormViewItem_1.FormViewItemFactoryFromJS)(i)) : [];
    return (0, exports.FormViewPayloadFactory)({
        windowId: data.windowId,
        originalActionType: data.originalActionType,
        views: (0, immutable_1.List)(views),
        pluginId: data.pluginId,
        sourceWindowId: data.sourceWindowId,
        autoClean: data.autoClean,
        view: data.view ? (0, IFormViewItem_1.FormViewItemFactoryFromJS)(data.view) : null,
        updatedViewName: data.updatedViewName
    });
};
exports.FormViewPayloadFactoryFromJS = FormViewPayloadFactoryFromJS;
//# sourceMappingURL=IFormViewPayload.js.map